import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BeneficiarioPagamento } from '../../../models/beneficiario-pagamento';
import { Pagamento } from '../../../models/pagamento';

import { tipiBeneficiarioPagamentoOptions } from '../../../models/tipologiche/mock-tipo-beneficiario';

@Component({
    selector: '[add_doc_to_pagamento]',
  templateUrl: 'add-to-pagamento.component.html',
})

export class AddDocumentoToPagamentoComponent {
  @Input()
  pagamento: Pagamento;
  @Input()
  pagamenti: Pagamento[];
  @Input()
  index: string;
  @Output()
  beneficiarioPagamento = new EventEmitter();
  @Output()
  onClickAddToEntity = new EventEmitter();

  private beneficiario: BeneficiarioPagamento = new BeneficiarioPagamento();

  ngOnInit() {
    if (this.pagamento.controparte) {
      this.beneficiario.idParent = this.pagamento.controparte.id;
      this.beneficiario.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '1'; })[0];
      this.beneficiario.persona = this.pagamento.controparte.parte;
    }
    if (this.pagamento.legaleIncaricato) {
      this.beneficiario.idParent = this.pagamento.legaleIncaricato.id;
      this.beneficiario.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '2'; })[0];
      this.beneficiario.persona = this.pagamento.legaleIncaricato.legale;
    }
    if (this.pagamento.altraParte) {
      this.beneficiario.idParent = this.pagamento.altraParte.id;
      this.beneficiario.tipoBeneficiarioPagamento = tipiBeneficiarioPagamentoOptions.filter(tB => { return tB.id === '3'; })[0];
      this.beneficiario.persona = this.pagamento.altraParte.parte;
    }
  }

  emitEntity(pagamento: Pagamento, beneficiario: BeneficiarioPagamento) {
    this.onClickAddToEntity.emit(pagamento);
    this.beneficiarioPagamento.emit(beneficiario);
  }
}
